import { render, staticRenderFns } from "./locationLengd.vue?vue&type=template&id=06390083&scoped=true"
import script from "./locationLengd.vue?vue&type=script&lang=js"
export * from "./locationLengd.vue?vue&type=script&lang=js"
import style0 from "./locationLengd.vue?vue&type=style&index=0&id=06390083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06390083",
  null
  
)

export default component.exports